import { HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Subscription, Observable, of } from 'rxjs';
import { CandidateStore } from '../../../../store/candidate-store';
import { AppModalComponent } from '../../../../../shared/components/app-modal/app-modal.component';
import { RegexStrings } from '../../../../../shared/constants/regex-strings';
import { StaticFilePaths } from '../../../../../shared/constants/static-file-paths';
import { AttachmentTypes } from '../../../../../shared/enums/attachment-types';
import { FileHelper } from '../../../../../shared/helpers/file-helper';
import { ModalConfigHelper } from '../../../../../shared/helpers/modal-config-helper';
import { RegexPatternHelper } from '../../../../../shared/helpers/regex-pattern-helper';
import { ModalConfig } from '../../../../../shared/models/modal.config';
import {
  PortfolioAttachment,
  PreviewAttachment,
} from 'src/app/shared/models/portfolio-attachment';
import { UploadStatus } from 'src/app/shared/models/upload-status';
import { FileService } from 'src/app/shared/services/file.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-portfolio-attachment',
  templateUrl: './portfolio-attachment.component.html',
  styleUrls: ['./portfolio-attachment.component.scss'],
})
export class PortfolioAttachmentComponent implements OnInit {
  @ViewChild('attachmentmodal') private modalComponent: AppModalComponent;
  @Input() resumeId: string;
  modalConfig: ModalConfig;
  attachmentTypes = AttachmentTypes;
  portfolioAttachment: PreviewAttachment;
  acceptedAttachmentFiles: string;
  formData: FormData;
  uploadStatus: UploadStatus;
  subscription: Subscription;

  constructor(
    private candidateStore: CandidateStore,
    private fileService: FileService
  ) {
    this.modalConfig = ModalConfigHelper.getAtachmentModalConfig(
      this.onDismiss,
      this.onClose
    );
    this.portfolioAttachment = new PreviewAttachment();
    this.formData = new FormData();
    this.uploadStatus = new UploadStatus();
    this.uploadStatus.progress = 0;
    this.acceptedAttachmentFiles = FileHelper.getAllowedAttachments();
  }

  ngOnInit() {
    this.candidateStore.openPortfolioDialog$.subscribe((state: boolean) => {
      if (state) {
        this.handleAddMediaClick();
      } else {
      }
    });
  }

  handleAddMediaClick = () => {
    this.candidateStore.setPortfolioDialogState(false);
    this.portfolioAttachment.resumeId = this.resumeId;
    this.modalComponent.open();
  };

  onClose = async (): Promise<boolean> => {
    if (!this.isValidData()) {
      this.uploadStatus.status = 'Attachment file is required.';
      return false;
    }
    if (this.portfolioAttachment.attachmentType == this.attachmentTypes.URL) {
      this.processImagePath();
      this.candidateStore.addPortfolio(this.portfolioAttachment);
      this.resetForm();
      return true;
    } else {
      
      return this.processFileToServer();
    }
  };

  processImagePath(): string {
    if (this.portfolioAttachment != null) {
      if (this.portfolioAttachment.attachmentType == this.attachmentTypes.URL) {
        this.portfolioAttachment.isYoutubeVideoLink =
          RegexPatternHelper.isValidPattern(
            this.portfolioAttachment.url,
            RegexStrings.YOUTUBE_VIDEO_LINK
          );
        this.portfolioAttachment.isAudioLink =
          RegexPatternHelper.isValidPattern(
            this.portfolioAttachment.url,
            RegexStrings.AUDIO_LINK
          );
        this.portfolioAttachment.attachmentUIPath =
          this.portfolioAttachment.isYoutubeVideoLink ||
            this.portfolioAttachment.isAudioLink
            ? `${this.portfolioAttachment.url}`
            : `/${StaticFilePaths.PreviewImage}`;
      } else {
        this.portfolioAttachment.fileType = FileHelper.getFileType(
          this.portfolioAttachment.filePath
        );
        
        this.portfolioAttachment.attachmentUIPath = `${environment.baseUrl}/${this.portfolioAttachment.filePath}`;
      }
      return;
    }
  }
  processFileToServer = async () => {
    const fileRequest = { formData: this.formData, reportProgress: true };
    this.fileService.uploadFile(fileRequest.formData).subscribe((event) => {
      if (event.type === HttpEventType.UploadProgress)
        this.uploadStatus.progress = Math.round(
          (100 * event.loaded) / event.total
        );
      else if (event.type === HttpEventType.Response) {
        this.uploadStatus.success = event.status == 200;
        this.portfolioAttachment.filePath = event.body['dbPath'];
        this.processImagePath();
        this.candidateStore.addPortfolio(this.portfolioAttachment);
        this.resetForm();
      }
    });

    return true;
  };

  onDismiss = (): Observable<boolean> => {
    return of<boolean>(true);
  };

  handleFileUpload = (files: File[]) => {
    if (files.length === 0) {
      return;
    }
    this.portfolioAttachment.attachmentType = this.attachmentTypes.File;
    const fileToUpload = files[0];
    if (fileToUpload.size > (25 * 1024 * 1024)) {
      alert("File exceeded the maximum allowed size. Please upload a smaller file.");
      return;
    }

    this.formData = new FormData();
    this.formData.append('acceptedFiles', this.acceptedAttachmentFiles);
    this.formData.append('file', fileToUpload, fileToUpload.name);
  };

  isValidData = (): boolean => {
    const data = this.portfolioAttachment;
    return !!
      ((data.attachmentType == this.attachmentTypes.URL && data.url) ||
        (data.attachmentType == this.attachmentTypes.File &&
          this.formData &&
          this.formData.has('file')));
  };

  private resetForm(): void {
    this.portfolioAttachment = new PreviewAttachment();
    this.formData = new FormData();
    this.uploadStatus = new UploadStatus();
    this.uploadStatus.progress = 0;
  }

  ngOnDestroy = () => {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  };
}
